import {
  ArrowTrendingUpIcon,
  BanknotesIcon,
  CalculatorIcon,
  ClockIcon,
} from '@heroicons/react/24/outline';
import React from 'react';
import { InventoryCostsSummary } from '../../services/inventoryCostsApi';

const fmt = (v: string | number): string =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(v));

export const KpiCards: React.FC<{ summary: InventoryCostsSummary }> = ({ summary }) => {
  const items = [
    {
      label: 'Spent This Period',
      value: fmt(summary.spent_period),
      Icon: ClockIcon,
      color: 'text-indigo-600',
    },
    {
      label: 'Spent YTD',
      value: fmt(summary.spent_ytd),
      Icon: ArrowTrendingUpIcon,
      color: 'text-blue-600',
    },
    {
      label: 'Avg Recon / Vehicle',
      value: fmt(summary.avg_recon_per_vehicle),
      Icon: CalculatorIcon,
      color: 'text-purple-600',
    },
    {
      label: 'Total Cost Basis',
      value: fmt(summary.total_cost_basis),
      Icon: BanknotesIcon,
      color: 'text-green-600',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {items.map(({ label, value, Icon, color }) => (
        <div key={label} className="bg-white rounded-lg shadow p-4 border border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">{label}</p>
              <p className="text-2xl font-bold text-gray-900">{value}</p>
            </div>
            <Icon className={`h-8 w-8 ${color}`} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default KpiCards;
